import '../helpers.js';
import '../shared/horizontal-scroll-edge.js';
import '../shared/truncated-text-hover-scroll.js';
import { initScrollBulkActionsIntoView } from '../shared/scroll-bulk-actions-into-view.js';
import '../manager/pledges/pledge-status.js';
import '../mobile-floating-bar.js';
import '../shared/pledges-grid-helpers.js';
import { initMemberPledgesGrid } from './member-pledges-grid.js';
import { initMemberPledgePageIfPresent } from './member-pledge-page.js';

export { initMemberPledgesGrid, initMemberPledgePageIfPresent };

export function initMemberNavDeps() {
    initScrollBulkActionsIntoView();
    initMemberPledgesGrid();
    initMemberPledgePageIfPresent();
}
